import { render, staticRenderFns } from "./AlertInsuranceRecommend.vue?vue&type=template&id=bde35bd0&scoped=true"
import script from "./AlertInsuranceRecommend.vue?vue&type=script&lang=js"
export * from "./AlertInsuranceRecommend.vue?vue&type=script&lang=js"
import style0 from "./AlertInsuranceRecommend.vue?vue&type=style&index=0&id=bde35bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde35bd0",
  null
  
)

export default component.exports